export * from './tabs-page.view';
export * from './tab-config';